export default __webpack_public_path__ + "static/media/2.92ffc972.jpg";